import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectUserV2 = _resolveComponent("SelectUserV2")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_UserEditionLight = _resolveComponent("UserEditionLight")!
  const _component_MergeUsers = _resolveComponent("MergeUsers")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
    title: "Utilisateurs",
    "min-width": '800px',
    "max-width": '800px',
    actions: _ctx.actions,
    onPrevious: _ctx.previousStep,
    "previous-display": ['createUser', 'mergeUser'].includes(_ctx.currentStep)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.currentStep,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentStep) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "selectUser" }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectUserV2, {
                ref: "selectUser",
                withEmail: true,
                companyId: _ctx.selectedCompany.id,
                type: _ctx.type,
                actions: _ctx.actions,
                height: "56vh",
                onUsersToMerge: _ctx.usersMerge,
                onCreateUserStep: _ctx.createUserStep,
                onDisableMergeButton: _ctx.disableMerging,
                onEditUser: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editUser($event))),
                onEmitActions: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActions()))
              }, null, 8, ["companyId", "type", "actions", "onUsersToMerge", "onCreateUserStep", "onDisableMergeButton"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "createUser" }, {
            default: _withCtx(() => [
              _createVNode(_component_UserEditionLight, {
                ref: "userEdition",
                actions: _ctx.actions,
                id: _ctx.user.id,
                onUserUpserted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.userUpserted()))
              }, null, 8, ["actions", "id"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "mergeUser" }, {
            default: _withCtx(() => [
              _createVNode(_component_MergeUsers, {
                actions: _ctx.actions,
                userIdsToMerge: _ctx.userIdsToMerge,
                onUserToKeep: _ctx.userToKeep,
                onMergeDone: _ctx.previousStep
              }, null, 8, ["actions", "userIdsToMerge", "onUserToKeep", "onMergeDone"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "actions", "onPrevious", "previous-display"]))
}